"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditGrowCycleModal = EditGrowCycleModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var pagination_1 = require("../../../constants/pagination");
var grow_cycle_1 = require("../../../features/apis/grow-cycle");
var api_error_message_1 = require("../../../utils/api-error-message");
var paginated_content_1 = require("../../../utils/paginated-content");
var permission_error_1 = require("../../../utils/permission-error");
var use_debounce_1 = require("../../../utils/use-debounce");
var loader_1 = require("../../loader");
var button_component_1 = require("../../ui/button-component");
var labeled_text_field_1 = require("../../ui/labeled-text-field");
var text_component_1 = require("../../ui/text-component");
var AREA_PAGE_SIZE = 30;
function areaLabel(area) {
    return area.display_name || area.name || "Unnamed area";
}
function initialArea(growCycle) {
    return growCycle.area ? { id: growCycle.area.id, name: growCycle.area.name } : null;
}
function EditGrowCycleModal(props) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var isOpen = props.isOpen, growCycle = props.growCycle, onClose = props.onClose, onUpdated = props.onUpdated;
    var _f = (0, react_2.useState)((_a = growCycle.display_name) !== null && _a !== void 0 ? _a : ""), name = _f[0], setName = _f[1];
    var _g = (0, react_2.useState)(initialArea(growCycle)), selectedArea = _g[0], setSelectedArea = _g[1];
    var areaId = (_b = selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.id) !== null && _b !== void 0 ? _b : "";
    var _h = (0, react_2.useState)(""), areaSearch = _h[0], setAreaSearch = _h[1];
    var _j = (0, react_2.useState)(""), error = _j[0], setError = _j[1];
    var debouncedAreaSearch = (0, use_debounce_1.useDebouncedValue)(areaSearch);
    var _k = (0, grow_cycle_1.useUpdateGrowCycleMutation)(), updateGrowCycle = _k[0], isUpdating = _k[1].isLoading;
    var _l = (0, grow_cycle_1.useGetGrowCycleAreasQuery)({ growCycleId: growCycle.id, size: AREA_PAGE_SIZE, pageNumber: pagination_1.DEFAULT_PAGE_NUMBER, search: debouncedAreaSearch || undefined }, { skip: !isOpen }), areasData = _l.currentData, isLoadingAreas = _l.isLoading, isAreasError = _l.isError, areasError = _l.error, refetchAreas = _l.refetch;
    // The selected area may not be in the current results (paged or filtered out); keep it in the list so the Select can still show it.
    var areas = (0, react_2.useMemo)(function () {
        var items = (0, paginated_content_1.getContentItems)(areasData);
        return selectedArea && !items.some(function (area) { return area.id === selectedArea.id; }) ? __spreadArray([selectedArea], items, true) : items;
    }, [areasData, selectedArea]);
    var requestTokenRef = (0, react_2.useRef)(0);
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () {
        var _a;
        setName((_a = growCycle.display_name) !== null && _a !== void 0 ? _a : "");
        setSelectedArea(initialArea(growCycle));
    }, [growCycle]);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var trimmedName = name.trim();
    var nameChanged = trimmedName !== ((_c = growCycle.display_name) !== null && _c !== void 0 ? _c : "");
    var areaChanged = !!areaId && areaId !== ((_e = (_d = growCycle.area) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : "");
    var hasChanges = nameChanged || areaChanged;
    var handleClose = function () {
        var _a;
        if (requestInFlightRef.current || isUpdating) {
            return;
        }
        requestTokenRef.current += 1;
        setName((_a = growCycle.display_name) !== null && _a !== void 0 ? _a : "");
        setSelectedArea(initialArea(growCycle));
        setAreaSearch("");
        setError("");
        onClose();
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var changes, requestToken, response, caught_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isUpdating) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!trimmedName) {
                        setError("Please enter a grow cycle name.");
                        return [2 /*return*/];
                    }
                    if (!hasChanges) {
                        handleClose();
                        return [2 /*return*/];
                    }
                    changes = __assign(__assign({ id: growCycle.id }, (nameChanged ? { display_name: trimmedName } : {})), (areaChanged ? { area_id: areaId } : {}));
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateGrowCycle(changes).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success || !response.content) {
                        setError(response.message || "Unable to update this grow cycle. Please try again.");
                        return [2 /*return*/];
                    }
                    onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated(response.content);
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    caught_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(caught_1, "Unable to update this grow cycle. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isUpdating, isKeyboardDismissDisabled: isUpdating, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[520px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isUpdating, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Edit Grow Cycle" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(labeled_text_field_1.LabeledTextField, { label: "Grow Cycle Name", value: name, onChange: setName, placeholder: "Grow cycle name", isRequired: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "medium", color: "dark-gray-1", label: "Area" }), (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Search areas", value: areaSearch, onChange: setAreaSearch, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Search areas", className: "rounded-md" }) }), (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "Choose Area", placeholder: "Choose area", selectedKey: areaId || null, onSelectionChange: function (key) { var _a; return setSelectedArea((_a = areas.find(function (area) { return area.id === String(key); })) !== null && _a !== void 0 ? _a : null); }, isDisabled: isLoadingAreas && areas.length === 0, children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "rounded-md", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: isLoadingAreas && areas.length === 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "px-4 py-3", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "sm", label: "Loading areas" }) })) : ((0, jsx_runtime_1.jsx)(react_1.ListBox, { children: areas.map(function (area) { return ((0, jsx_runtime_1.jsx)(react_1.ListBox.Item, { id: area.id, textValue: areaLabel(area), children: areaLabel(area) }, area.id)); }) })) })] })] }), isAreasError && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-xs text-red-600", children: [(0, jsx_runtime_1.jsx)("span", { children: (0, permission_error_1.getLoadErrorMessage)(areasError, "Unable to load areas.") }), !(0, permission_error_1.isPermissionDeniedError)(areasError) && ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: function () { return refetchAreas(); }, className: "underline cursor-pointer", children: "Retry" }))] })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isUpdating, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Save Changes", onPress: handleSave, isPending: isUpdating, isDisabled: !trimmedName || !hasChanges, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
